// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import Not_foundPng from "./not_found.png";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let imageUri = Not_foundPng;
let styles = {
  container: {
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "width-kzqmXN": "width-xbstwhj",
    $$css: "wino-gc:src/app/Error/NotFoundPage.res.js:16"
  },
  image: {
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "height-kZKoxP": "height-xzu4f96",
    "marginBottom-k1K539": "marginBottom-x1hq5gj4",
    "marginTop-keoZOQ": "marginTop-xei8oxt",
    "width-kzqmXN": "width-xjmwvv9",
    $$css: "wino-gc:src/app/Error/NotFoundPage.res.js:24"
  },
  action: {
    "alignSelf-kSGwAc": "alignSelf-xamitd3",
    "paddingTop-kLKAdn": "paddingTop-x1cnzs8",
    $$css: "wino-gc:src/app/Error/NotFoundPage.res.js:33"
  }
};
function NotFoundPage(props) {
  let match = Navigation.useGoBack();
  let onGoBack = match[1];
  let canGoBack = match[0];
  let newrecord = {
    ...{
      className: "alignSelf-xamitd3 display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf justifyContent-xl56j7k width-xbstwhj",
      "data-style-src": "wino-gc:src/app/Error/NotFoundPage.res.js:16"
    }
  };
  let newrecord$1 = {
    ...{
      className: "alignSelf-xamitd3 display-x78zum5 flexDirection-xdt5ytf height-xzu4f96 marginBottom-x1hq5gj4 marginTop-xei8oxt width-xjmwvv9",
      "data-style-src": "wino-gc:src/app/Error/NotFoundPage.res.js:24"
    }
  };
  let newrecord$2 = {
    ...{
      className: "alignSelf-xamitd3 paddingTop-x1cnzs8",
      "data-style-src": "wino-gc:src/app/Error/NotFoundPage.res.js:33"
    }
  };
  newrecord.children = [JsxRuntime.jsx("img", (newrecord$1.src = imageUri, newrecord$1)), JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsx(Title.make, {
      children: I18n.t("Ooops ! This page doesn't seem available now."),
      align: "center"
    }), JsxRuntime.jsx(TextStyle.make, {
      children: I18n.t("Please try refreshing the page."),
      align: "center",
      size: "huge"
    }), JsxRuntime.jsx("div", (newrecord$2.children = JsxRuntime.jsx(Button.make, {
      label: I18n.t("Go back to the previous page"),
      onPress: () => {
        if (canGoBack) {
          return onGoBack();
        }
      }
    }), newrecord$2))],
    space: "normal"
  })];
  return JsxRuntime.jsxs("div", newrecord);
}
let make = NotFoundPage;
export { imageUri, styles, make };
/* imageUri Not a pure module */